export default {
    en: {
        search: 'Search',
        device: 'All device',
        select: 'Select a behaviour',
        reset: 'Reset',
        title: 'Browse behaviours',
        searchImage: 'Search by image',
        route: 'Route',
        developRoute: 'Generate Route',
        selectTime: 'Last 7 days',
        cancel: 'Cancel',
        selected: 'Selected',
        clearAll: 'Clear All',
        addedRoute: 'Added  to route',
        addRoute: 'Add to route',
        deleteRoute: 'Delete from route',
        detail: 'Detail',
        photo: 'Photo',
        similarity: 'Similarity',
        features: 'Features',
        time: 'Time',
        deviceName: 'Device',
        reults: 'results',
        layer: 'Layer',
        hideAll: 'Hide all',
        showAll: 'Show all',
        tips: 'No Retrievable Object',
        multiple: 'Multiple Devices',
        face: 'Face',
        body: 'Body',
        vehicle: 'Vehicle',
        click: 'click to upload or drag a image here',
        formatError: 'Invalid image format /size',
        upload: 'upload',
        unqualified: 'The image format is unqualified',
        reUpload: 'please upload again',
        selectInput: 'Enter license plate number',
        pleaseSelectInput: 'Please enter the license plate number, the system supports fuzzy search',
        event: 'Event',
        vehicleNo: 'Vehicle',
        Image: "Image",
        picture: "Image",
        portraitLibaryPhoto: 'Library Portrait',
        portraitLibary: 'Portrait Libary',
        snapImage: 'Capture Portrait',
        track: 'The number of selected trajectory restoration records reaches the maximum limit of 50.',
        sizeError: 'File size exceeds ',
        result: '{count} results',
        ok: "OK",
        text: 'Text',
        textInput: 'Enter text to search'
    },
    zh: {
        snapImage: '抓拍图',
        search: '搜索',
        device: '设备列表',
        select: '请选择',
        reset: '重置',
        title: '可检索任务类型',
        searchImage: '以图像搜索',
        route: '轨迹',
        developRoute: '轨迹还原',
        selectTime: '最近7天',
        cancel: '取消',
        selected: '选中',
        clearAll: '全部删除',
        addedRoute: '已添加到轨迹',
        addRoute: '添加轨迹',
        deleteRoute: '删除轨迹',
        detail: '详情',
        photo: '目标图',
        similarity: '相似度',
        features: '特征',
        time: '时间',
        deviceName: '设备',
        reults: '条',
        layer: '算法图层',
        hideAll: '收起',
        showAll: '展开',
        tips: '未找到可检索对象',
        multiple: '多个设备',
        face: '人脸',
        body: '人体',
        vehicle: '车辆',
        click: '点击或拖拽上传',
        formatError: '图片格式/大小无效',
        upload: '上传',
        unqualified: '图片格式不合格',
        reUpload: '请重新上传',
        selectInput: '输入车牌号',
        pleaseSelectInput: '请输入车牌号，系统支持模糊检索',
        event: '事件',
        vehicleNo: '车牌',
        Image: "图片",
        picture: "图片",
        portraitLibaryPhoto: '人像',
        portraitLibary: '人像库',
        track: '轨迹还原时空卡片数达到50张最大限制',
        sizeError: '图片大小超过',
        result: '{count} 结果',
        ok: "确定",
        text: '文本',
        textInput: '请输入文本'
    },
};
